// src/hooks/useNotices.js
import { useState, useEffect, useCallback } from "react";
import { getNotices } from "./noticeApi";

export const useNotices = (itemsPerPage = 4) => {
  const [notices, setNotices] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    const fetchNotices = async () => {
      try {
        if (page === 1) setIsLoading(true);
        else setIsFetching(true);

        const response = await getNotices(page, itemsPerPage);

        setNotices((prev) => [...prev, ...response.data]);
        setHasMore(response.hasMore);
      } catch (error) {
        console.error("데이터를 불러오는데 실패했습니다.", error);
      } finally {
        setIsLoading(false);
        setIsFetching(false);
      }
    };

    fetchNotices();
  }, [page, itemsPerPage]);

  const loadMore = useCallback(() => {
    if (!isFetching && hasMore) {
      setPage((prev) => prev + 1);
    }
  }, [isFetching, hasMore]);

  return {
    notices,
    isLoading,
    isFetching,
    hasMore,
    loadMore,
  };
};
